module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/loading-buttons/loading-buttons.component.scss
// module id = ./src/app/features/buttons/loading-buttons/loading-buttons.component.scss
// module chunks = main